import { useRef, useEffect, useState } from "react";
import _ from "lodash";
import { Col, Row, Statistic } from 'antd';
import dayjs from "dayjs";
import { useDataStore } from "../../../store";

//消金平台详细数据统计
export function FinancialDetailModule (){
    const content = useDataStore( state => state.riskItems );
    const getOrderDetail = useDataStore( state => state.getOrderDetail );
    const [data, setData] = useState({
        //平台数
        'financialPlatformCount': 0,
        //还款次数
        'paymentCount': 0,
        //已支付金额
        'paymentAmount': 0,
        //平均月还款金额
        'avgPaymentAmount': 0,
    });
    const dataKeyMap = {
        'financialPlatformCount': '消金平台数',
        'paymentCount': '还款次数',
        'paymentAmount': '已支付金额',
        'avgPaymentAmount': '平均月还款金额'
    }
    useEffect(() => {
        let monthSet = new Set();
        _.entries( content.financialPlatform ).forEach(([ key, orders ]) => {
            orders.forEach( order => {
                const orderDetail = getOrderDetail(order);
                if((orderDetail._IE === 1 || orderDetail._IE === 2) && orderDetail.AMOUNT > 0 ){
                    data.paymentAmount = _.round(data.paymentAmount + orderDetail.AMOUNT, 2);
                    data.paymentCount += 1;
                    if( orderDetail.TIME_YMD ){
                        monthSet.add( dayjs(orderDetail.TIME_YMD).format('YYYY-MM') );
                    }
                }
            });
        });
        data.financialPlatformCount = _.size( content.financialPlatform );
        let monthCount = monthSet.size;
        data.avgPaymentAmount = monthCount > 0 ? _.round(data.paymentAmount / monthCount, 2) : 0;
        setData({...data});
    }, [ content, getOrderDetail ]);

    return <Row direction="hozizontal" gutter={[24, 24]} style={{ marginBottom: '24px' }}>
        {Object.entries(data).map(([key, value]) => {
            return <Col span={6} key={key}>
                <Statistic title={dataKeyMap[key]} value={value} />
            </Col>
        })}
    </Row>
}
